import React from "react";
import PropTypes from "prop-types";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import moment from "moment";
import { eventTypeIds } from "../../../constants";
var tKey = "wrappers.NotificationToastsDecorator.impl.SubscriptionRelatedNotificationToast";
function SubscriptionRelatedNotificationToast(props) {
  var notificationId = props.notificationId,
    eventTypeId = props.eventTypeId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var notification = useSelector(function (state) {
    return state.entities.notifications.byId[notificationId];
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, eventTypeId === eventTypeIds.SUBSCRIPTION_AUTHORIZED && t("".concat(tKey, ".header_authorized")), eventTypeId === eventTypeIds.SUBSCRIPTION_CANCELLED && t("".concat(tKey, ".header_cancelled")), eventTypeId === eventTypeIds.SUBSCRIPTION_PAUSED && t("".concat(tKey, ".header_paused")), "\xA0\xB7\xA0", moment(notification.createdAt).fromNow(true)), /*#__PURE__*/React.createElement("div", null, eventTypeId === eventTypeIds.SUBSCRIPTION_AUTHORIZED && /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".body_authorized")
  }), eventTypeId === eventTypeIds.SUBSCRIPTION_CANCELLED && /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".body_cancelled")
  }), eventTypeId === eventTypeIds.SUBSCRIPTION_PAUSED && /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".body_paused")
  })));
}
export default SubscriptionRelatedNotificationToast;
SubscriptionRelatedNotificationToast.propTypes = {
  notificationId: PropTypes.number.isRequired,
  eventTypeId: PropTypes.string.isRequired
};